// Generated by purs version 0.15.15
import * as Data_Bounded_Generic from "../Data.Bounded.Generic/index.js";
import * as Data_Enum_Generic from "../Data.Enum.Generic/index.js";
import * as Data_Generic_Rep from "../Data.Generic.Rep/index.js";
import * as Data_Ordering from "../Data.Ordering/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Foreign_Encoding from "../Foreign.Encoding/index.js";
import * as Foreign_Generic_EnumEncoding from "../Foreign.Generic.EnumEncoding/index.js";
import * as Restaumatic_Form_TestHelpers from "../Restaumatic.Form.TestHelpers/index.js";
import * as Unscramble_Enum from "../Unscramble.Enum/index.js";
var genericShowConstructor = /* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments);
var MenuBottomSheetIsSymbol = {
    reflectSymbol: function () {
        return "MenuBottomSheet";
    }
};
var CreatorIsSymbol = {
    reflectSymbol: function () {
        return "Creator";
    }
};
var CartIsSymbol = {
    reflectSymbol: function () {
        return "Cart";
    }
};
var CartBottomSheetIsSymbol = {
    reflectSymbol: function () {
        return "CartBottomSheet";
    }
};
var genericTopConstructor = /* #__PURE__ */ Data_Bounded_Generic.genericTopConstructor(Data_Bounded_Generic.genericTopNoArguments);
var genericBottomConstructor = /* #__PURE__ */ Data_Bounded_Generic.genericBottomConstructor(Data_Bounded_Generic.genericBottomNoArguments);
var genericBottomSum = /* #__PURE__ */ Data_Bounded_Generic.genericBottomSum(genericBottomConstructor);
var genericEnumConstructor = /* #__PURE__ */ Data_Enum_Generic.genericEnumConstructor(Data_Enum_Generic.genericEnumNoArguments);
var genericEnumSum = /* #__PURE__ */ Data_Enum_Generic.genericEnumSum(genericEnumConstructor)(genericTopConstructor);
var genericEnumSum1 = /* #__PURE__ */ genericEnumSum(/* #__PURE__ */ genericEnumSum(/* #__PURE__ */ genericEnumSum(genericEnumConstructor)(genericBottomConstructor))(genericBottomSum))(genericBottomSum);
var genericBoundedEnumConstructor = /* #__PURE__ */ Data_Enum_Generic.genericBoundedEnumConstructor(Data_Enum_Generic.genericBoundedEnumNoArguments);
var genericBoundedEnumSum = /* #__PURE__ */ Data_Enum_Generic.genericBoundedEnumSum(genericBoundedEnumConstructor);
var genericBoundedEnumSum1 = /* #__PURE__ */ genericBoundedEnumSum(/* #__PURE__ */ genericBoundedEnumSum(/* #__PURE__ */ genericBoundedEnumSum(genericBoundedEnumConstructor)));
var MenuBottomSheet = /* #__PURE__ */ (function () {
    function MenuBottomSheet() {

    };
    MenuBottomSheet.value = new MenuBottomSheet();
    return MenuBottomSheet;
})();
var Creator = /* #__PURE__ */ (function () {
    function Creator() {

    };
    Creator.value = new Creator();
    return Creator;
})();
var Cart = /* #__PURE__ */ (function () {
    function Cart() {

    };
    Cart.value = new Cart();
    return Cart;
})();
var CartBottomSheet = /* #__PURE__ */ (function () {
    function CartBottomSheet() {

    };
    CartBottomSheet.value = new CartBottomSheet();
    return CartBottomSheet;
})();
var eqCrossSellingPlace = {
    eq: function (x) {
        return function (y) {
            if (x instanceof MenuBottomSheet && y instanceof MenuBottomSheet) {
                return true;
            };
            if (x instanceof Creator && y instanceof Creator) {
                return true;
            };
            if (x instanceof Cart && y instanceof Cart) {
                return true;
            };
            if (x instanceof CartBottomSheet && y instanceof CartBottomSheet) {
                return true;
            };
            return false;
        };
    }
};
var ordCrossSellingPlace = {
    compare: function (x) {
        return function (y) {
            if (x instanceof MenuBottomSheet && y instanceof MenuBottomSheet) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof MenuBottomSheet) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof MenuBottomSheet) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof Creator && y instanceof Creator) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof Creator) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof Creator) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof Cart && y instanceof Cart) {
                return Data_Ordering.EQ.value;
            };
            if (x instanceof Cart) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof Cart) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof CartBottomSheet && y instanceof CartBottomSheet) {
                return Data_Ordering.EQ.value;
            };
            throw new Error("Failed pattern match at Restaumatic.Analytics.Types.CrossSellingPlace (line 0, column 0 - line 0, column 0): " + [ x.constructor.name, y.constructor.name ]);
        };
    },
    Eq0: function () {
        return eqCrossSellingPlace;
    }
};
var genericCrossSellingPlace = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return MenuBottomSheet.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
            return Creator.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inl)) {
            return Cart.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inr)) {
            return CartBottomSheet.value;
        };
        throw new Error("Failed pattern match at Restaumatic.Analytics.Types.CrossSellingPlace (line 17, column 1 - line 17, column 89): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof MenuBottomSheet) {
            return new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value);
        };
        if (x instanceof Creator) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value));
        };
        if (x instanceof Cart) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value)));
        };
        if (x instanceof CartBottomSheet) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(Data_Generic_Rep.NoArguments.value)));
        };
        throw new Error("Failed pattern match at Restaumatic.Analytics.Types.CrossSellingPlace (line 17, column 1 - line 17, column 89): " + [ x.constructor.name ]);
    }
};
var showCrossSellingPlace = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericCrossSellingPlace)(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor(MenuBottomSheetIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor(CreatorIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor(CartIsSymbol))(/* #__PURE__ */ genericShowConstructor(CartBottomSheetIsSymbol)))))
};
var unscrambleDecodeCrossSellingPlace = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Enum.genericUnsafeDecodeEnum(genericCrossSellingPlace)(/* #__PURE__ */ Unscramble_Enum.enumConstructorsSum(/* #__PURE__ */ Unscramble_Enum.enumConstructorsConstruct(MenuBottomSheetIsSymbol))(/* #__PURE__ */ Unscramble_Enum.enumConstructorsSum(/* #__PURE__ */ Unscramble_Enum.enumConstructorsConstruct(CreatorIsSymbol))(/* #__PURE__ */ Unscramble_Enum.enumConstructorsSum(/* #__PURE__ */ Unscramble_Enum.enumConstructorsConstruct(CartIsSymbol))(/* #__PURE__ */ Unscramble_Enum.enumConstructorsConstruct(CartBottomSheetIsSymbol)))))(Unscramble_Enum.defaultEnumOptions)
};
var boundedCrossSellingPlace = {
    top: /* #__PURE__ */ Data_Bounded_Generic.genericTop(genericCrossSellingPlace)(/* #__PURE__ */ Data_Bounded_Generic.genericTopSum(/* #__PURE__ */ Data_Bounded_Generic.genericTopSum(/* #__PURE__ */ Data_Bounded_Generic.genericTopSum(genericTopConstructor)))),
    bottom: /* #__PURE__ */ Data_Bounded_Generic.genericBottom(genericCrossSellingPlace)(genericBottomSum),
    Ord0: function () {
        return ordCrossSellingPlace;
    }
};
var enumCrossSellingPlace = {
    succ: /* #__PURE__ */ Data_Enum_Generic.genericSucc(genericCrossSellingPlace)(genericEnumSum1),
    pred: /* #__PURE__ */ Data_Enum_Generic.genericPred(genericCrossSellingPlace)(genericEnumSum1),
    Ord0: function () {
        return ordCrossSellingPlace;
    }
};
var boundedEnumCrossSellingPl = {
    cardinality: /* #__PURE__ */ Data_Enum_Generic.genericCardinality(genericCrossSellingPlace)(genericBoundedEnumSum1),
    toEnum: /* #__PURE__ */ Data_Enum_Generic.genericToEnum(genericCrossSellingPlace)(genericBoundedEnumSum1),
    fromEnum: /* #__PURE__ */ Data_Enum_Generic.genericFromEnum(genericCrossSellingPlace)(genericBoundedEnumSum1),
    Bounded0: function () {
        return boundedCrossSellingPlace;
    },
    Enum1: function () {
        return enumCrossSellingPlace;
    }
};
var toFillFormTypeCrossSellin = {
    fillFormDataType: /* #__PURE__ */ Restaumatic_Form_TestHelpers.defaultEnumFillFormDataType(genericCrossSellingPlace)(/* #__PURE__ */ Restaumatic_Form_TestHelpers.gEnumToFillFormTypeSum(/* #__PURE__ */ Restaumatic_Form_TestHelpers.gEnumToFillFormTypeConstr(MenuBottomSheetIsSymbol))(/* #__PURE__ */ Restaumatic_Form_TestHelpers.gEnumToFillFormTypeSum(/* #__PURE__ */ Restaumatic_Form_TestHelpers.gEnumToFillFormTypeConstr(CreatorIsSymbol))(/* #__PURE__ */ Restaumatic_Form_TestHelpers.gEnumToFillFormTypeSum(/* #__PURE__ */ Restaumatic_Form_TestHelpers.gEnumToFillFormTypeConstr(CartIsSymbol))(/* #__PURE__ */ Restaumatic_Form_TestHelpers.gEnumToFillFormTypeConstr(CartBottomSheetIsSymbol)))))
};
var encodeCrossSellingPlace = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEnumEncode(genericCrossSellingPlace)(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericEncodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericEncodeEnum(MenuBottomSheetIsSymbol))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericEncodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericEncodeEnum(CreatorIsSymbol))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericEncodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericEncodeEnum(CartIsSymbol))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericEncodeEnum(CartBottomSheetIsSymbol)))))
};
var decodeCrossSellingPlace = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultEnumDecode(genericCrossSellingPlace)(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericDecodeEnum(MenuBottomSheetIsSymbol))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericDecodeEnum(CreatorIsSymbol))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericDecodeEnum(CartIsSymbol))(/* #__PURE__ */ Foreign_Generic_EnumEncoding.ctorNoArgsGenericDecodeEnum(CartBottomSheetIsSymbol)))))
};
export {
    MenuBottomSheet,
    Creator,
    Cart,
    CartBottomSheet,
    genericCrossSellingPlace,
    eqCrossSellingPlace,
    showCrossSellingPlace,
    encodeCrossSellingPlace,
    decodeCrossSellingPlace,
    unscrambleDecodeCrossSellingPlace,
    ordCrossSellingPlace,
    enumCrossSellingPlace,
    boundedCrossSellingPlace,
    boundedEnumCrossSellingPl,
    toFillFormTypeCrossSellin
};
